import React, { useEffect } from "react";
import Main from "./routes/Main";
import { Layout } from "./components/Layout";
import Loader from "./components/Loader";
import { CompanyDetails } from "./api/CompanyDetailsApi";
import { dynamicFailed } from "./hooks/custom/useToast";
import { useCompanyDetailsContext } from "./context/CompanyDetailsContext";
import { useBrochureContext } from "./context/BrochureContext";
import {
  fetchMPPBrochure,
  fetchOurBrochure,
  fetchUndergraduateBrochure,
} from "./api/BrochureApi";

const MainPage = () => {
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  const {
    brochureData,
    setBrochureData,
    undergraduateBrochureData,
    setUndergraduateBrochureData,
    mppBrochureData,
    setMppBrochureData,
  } = useBrochureContext();

  useEffect(() => {
    if (companyDetailsData[0]?.company_name) {
      document.title = companyDetailsData[0].company_name;
    }

    if (!companyDetailsData[0]?.favicon_color) return;

    let link = document.querySelector("link[rel~='icon']");

    if (link instanceof HTMLLinkElement) {
      link.href = `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.favicon_color[0]?.media?.url}`;
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.favicon_color[0]?.media?.url}`;
      document.head.appendChild(newLink);
    }
  }, [companyDetailsData]);

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([CompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch((error) => {
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);

  useEffect(() => {
    if (
      brochureData.length === 0 ||
      undergraduateBrochureData.length === 0 ||
      mppBrochureData.length === 0
    ) {
      Promise.all([
        fetchOurBrochure(),
        fetchUndergraduateBrochure(),
        fetchMPPBrochure(),
      ])
        .then(
          ([ourbrochureData, undergraduateBrochureData, mppBrochureData]) => {
            setBrochureData(ourbrochureData);
            setUndergraduateBrochureData(undergraduateBrochureData);
            setMppBrochureData(mppBrochureData);
          },
        )
        .catch((error) => {
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [
    brochureData.length,
    mppBrochureData.length,
    setBrochureData,
    setMppBrochureData,
    setUndergraduateBrochureData,
    undergraduateBrochureData.length,
  ]);

  return (
    <>
      {window.location.pathname.startsWith("/announcement") ? (
        <Main />
      ) : (
        <Layout>
          <Main />
        </Layout>
      )}
      <Loader />
    </>
  );
};

export default MainPage;
